import { render, staticRenderFns } from "./WizardIntro.vue?vue&type=template&id=663d1be4&scoped=true"
import script from "./WizardIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardIntro.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WizardIntro.vue?vue&type=style&index=0&id=663d1be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d1be4",
  null
  
)

export default component.exports